var storefrontApp = angular.module('storefrontApp');

storefrontApp.component('vcPaymentMethods', {
    templateUrl: "themes/assets/js/common-components/paymentMethods.tpl.html",
    require: {
        checkoutStep: '?^vcCheckoutWizardStep'
    },
    bindings: {
        getPaymentMethodData: '&',
        onSelectMethod: '&',
        paymentMethod: '=',
        cart: '=',
        validationContainer: '=',
        onPaymentProfileChangedMethod: '&'
    },
    controller: ['$scope', function ($scope) {
        var ctrl = this;

        this.$onInit = function () {
            ctrl.getPaymentMethodData().then(function (response) {
                ctrl.availPaymentMethods = _.sortBy(response.paymentMethods, function (x) { return x.priority; });
                if (ctrl.paymentMethod) {
                    ctrl.paymentMethod = _.findWhere(ctrl.availPaymentMethods, { code: ctrl.paymentMethod.code });
                }
                if (!ctrl.paymentMethod && ctrl.availPaymentMethods.length > 0) {
                    ctrl.selectMethod(ctrl.availPaymentMethods[0]);
                }

                ctrl.authorizeNetCustomerProfile = response.authorizeNetCustomerProfile;
            });
            if (ctrl.validationContainer)
                ctrl.validationContainer.addComponent(this);
            if (ctrl.checkoutStep)
                ctrl.checkoutStep.addComponent(this);
        };

        this.$onDestroy = function () {
            if (ctrl.validationContainer)
                ctrl.validationContainer.removeComponent(this);
            if (ctrl.checkoutStep)
                ctrl.checkoutStep.removeComponent(this);
        };

        ctrl.validate = function () {
            return ctrl.paymentMethod;
        }

        ctrl.selectMethod = function (method) {
            ctrl.paymentMethod = method;
            ctrl.onSelectMethod({ paymentMethod: method });
        };

        ctrl.selectPaymentProfile = function (paymentProfile) {
            if (ctrl.onPaymentProfileChangedMethod) {
                ctrl.onPaymentProfileChangedMethod({ paymentProfile: paymentProfile });
            }
        };
    }]
});
